import { EventEmitter, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Component, Input, OnInit, Output } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-breakdown-header',
  templateUrl: './breakdown-header.component.html',
  styleUrls: ['./breakdown-header.component.scss']
})
export class BreakdownHeaderComponent implements OnInit,OnDestroy {
  @Input() isExpandable;
  @Input() isEditable: boolean;
  private _total: number;
  private destroy$ = new Subject<void>();
  @Input() set total(total: number) {
    this._total = total;
    
    if (!this.isEditable) {
      this.inputType = 'text';
      this.totalControl.setValue(Number(this.total)?this.decimalPipe.transform(this.total, '1.0-0'): this.total, {emitEvent: false});
    } else {
      this.inputType = 'number';
    this.totalControl.setValue(this.total, { emitEvent: false });

    }
  };
  get total() {
    return this._total;
  }
  @Input() title: boolean;
  @Output() valueChanges: EventEmitter<number> = new EventEmitter();
  isExpanded: boolean = false;
  totalControl: FormControl = new FormControl();
  inputType: 'text' | 'number';
  constructor(private decimalPipe: DecimalPipe) { }

  ngOnInit(): void {
    this.totalControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(e => {
      this.valueChanges.emit(e);
    });    
    
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  cancelEvent(e: MouseEvent) {
    e.stopPropagation();
  }

}
